import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  AnimationSettingsModel,
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';

import Message from '../../utils/Message/Message';
import './style.css';
import { all_information, loadingShow } from '../../App';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import axios from 'axios';
import {
  AddBusinessLogicConfiguration,
  DeleteBusinessLogicConfiguration,
  EditBusinessLogicConfiguration,
  getBusinessLogicConfiguration,
  getBusinessLogicConfigurationSqlValidate,
} from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
import {
  getTableWithColumnNames,
  getTask,
} from '../../services/Dig/TaskManager/TaskManagerServices';
const { Parser } = require('node-sql-parser');
interface IProps {}
interface IState {
  hideDialog: boolean;
  TaskData: any;
  GridData: any;
  sqlResult: any;
  hideDialogDeleteLogic: any;
  TaskWithColumnData: any;
}
class BusinessLogiConfiguration extends Component<IProps, IState> {
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  private animationSettings: AnimationSettingsModel;

  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  private fieldTask: object = {
    text: 'task_name',
    value: 'task_id',
  };
  private fieldComp: object = {
    text: 'compName',
    value: 'compID',
  };
  private fieldsTaskColumnList: object = {
    text: 'COLUMN_NAME',
    value: 'COLUMN_NAME',
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private DataComponent = [
    { compName: 'Control Centre', compID: 1 },
    { compName: 'Cloud Discovery', compID: 2 },
    { compName: 'Cloud Planner', compID: 3 },
    { compName: 'Cloud Execution', compID: 4 },
    { compName: 'Cloud Scheduler', compID: 10 },
    { compName: 'Close,Comp.Rep.', compID: 5 },
    { compName: 'Trade Planner', compID: 6 },
    { compName: 'TradePerson', compID: 7 },
    { compName: 'Asset Intelliagence', compID: 8 },
    { compName: 'Cloud Production Tracking', compID: 9 },
  ];
  private buttons: ButtonPropsModel[];
  private buttonsForDelete: ButtonPropsModel[];
  private gridLogic: any;
  private taskName = '';
  private description = '';
  private condition = '';
  private componentName = '';
  private textareaObjCondition: any;
  private taskObj: any;
  private isEdit = false;
  private LogicID = -1;
  private selectedCompIndex = 20;
  private targetTableText = '';
  
  private source = axios.CancelToken.source();
  constructor(props: IProps) {
    super(props);
    this.state = {
      hideDialog: false,
      TaskData: [],
      GridData: [],
      sqlResult: '',
      hideDialogDeleteLogic: false,
      TaskWithColumnData: [],
    };
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttons = [
      {
        click: () => {
          this.getValidateSql(false);
        },
        buttonModel: {
          content: 'Test Sql',
          isPrimary: false,
        },
      },
      {
        click: () => {
          this.getValidateSql(true);
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsForDelete = [
      {
        click: () => {
          this.deleteLogic();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDeleteLogic: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
  }
  async deleteLogic() {
    var obje = {
      ID: this.LogicID,
    };
    await DeleteBusinessLogicConfiguration(obje)
      .then((res) => {
        this.getBusinessLogicConfiguration();
        Message.success('Successful');
        this.setState({ hideDialogDeleteLogic: false });
      })
      .catch((err) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  getBusinessLogicConfiguration() {
    getBusinessLogicConfiguration({
      org_id: all_information.company_id,
    }).then((res) => {
      this.setState({ GridData: res.data });
    });
  }
  getTask() {
    getTask({ org_id: all_information.company_id }, undefined).then((res) => {
      this.setState({ TaskData: res.data });
    });
  }
  componentDidMount() {
    this.getTask();
    this.getBusinessLogicConfiguration();
  }
  componentWillUnmount(): void {
    if (this.source) {
    }
  }
  async createBusinessConfiguration() {
    const task_id = this.taskObj.value;
    const task_name = this.taskObj.text;
    const description = this.description;
    const condition = this.condition;
    const component_name = this.componentName;
    if (task_name === null) {
      Message.error('Can not be empty Task');
      return false;
    }
    if (description === '') {
      Message.error('Can not be empty Description');
      return false;
    }
    if (component_name === '') {
      Message.error('Can not be empty Component');
      return false;
    }
    loadingShow(true);
    var obje: any = {
      ID: this.LogicID,
      app: 'UWORK',
      organization_id: all_information.company_id?.toString(),
      created_by: all_information.user_id,
      task_id: task_id,
      description: description,
      condition: condition,
      component_name: component_name,
    };
    //('deneme');
    //(obje);
    if (!this.isEdit) {
      delete obje.ID;
      await AddBusinessLogicConfiguration(obje)
        .then((res) => {
          this.getBusinessLogicConfiguration();
          Message.success('Successful');
          this.dialogClose();
        })
        .catch((err) => {
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      await EditBusinessLogicConfiguration(obje)
        .then((res) => {
          this.getBusinessLogicConfiguration();
          Message.success('Successful');
          this.dialogClose();
        })
        .catch((err) => {
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }

    loadingShow(false);
  }
  getValidateSql(action: any) {
    const task_id = this.taskObj.value;
    const task_name = this.taskName;
    const condition = this.condition;
    if (task_name === '') {
      Message.error('Can not be empty Task');
      return false;
    }
    if (condition === '') {
      Message.error('Can not be empty Condition');
      return false;
    }
    const target_table = this.targetTableText;
    let message = '';
    if (condition !== '') {
      const parser = new Parser();
      const sql = 'select * from ' + target_table + ' where ' + condition;
      const ast = parser.astify(sql);
      let newSql = parser.sqlify(ast);
      newSql = newSql.replaceAll('`', '');
      const obj = {
        sql: newSql,
      };
      getBusinessLogicConfigurationSqlValidate(obj, this.source)
        .then((res) => {
          message = res.data;
          if (message.toString() !== '1') {
            Message.error(message);
            return false;
          } else {
            if (!action) {
              Message.success('Condition Validate Successful');
            }
            if (action) {
              this.createBusinessConfiguration();
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      if (action && message === '') {
        this.createBusinessConfiguration();
      }
    }
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.isEdit = false;
      this.taskName = '';
      this.description = '';
      this.condition = '';
      this.componentName = '';
      this.setState({ hideDialog: true });
    }
    if (args.item.id === 'edit') {
      if (this.gridLogic.getSelectedRecords().length !== 0) {
        this.isEdit = true;
        var data = this.gridLogic.getSelectedRecords()[0];
        this.taskObj = { text: data.task_name, value: data.task_id };
        this.taskName = data.task_name;
        this.description = data.description;
        this.componentName = data.component_name;
        this.condition = data.condition;
        this.setState({ hideDialog: true });
        this.LogicID = data.ID;

        var findCompIndex = this.DataComponent.findIndex(
          (x: any) => x.compName === data.component
        );
        this.selectedCompIndex = findCompIndex;
        $('.list-logic').css('display', 'flex');
      } else {
        Message.error('no records selected ');
      }
    }
    if (args.item.id === 'delete') {
      if (this.gridLogic.getSelectedRecords().length !== 0) {
        var data = this.gridLogic.getSelectedRecords()[0];
        this.LogicID = data.ID;
        this.setState({ hideDialogDeleteLogic: true });
      } else {
        Message.error('no records selected ');
      }
    }
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  private onCreateConditionTextArea(): void {
    this.textareaObjCondition.addAttributes({ rows: 5 });
    this.textareaObjCondition.respectiveElement.style.height = '200px';
    this.textareaObjCondition.respectiveElement.style.overflow = 'auto';
    this.textareaObjCondition.respectiveElement.style.maxHeight = '200px';
  }
  rowSelect = (el: any) => {
    try {
      var target_table = this.state.TaskData.find(
        (x: any) => x.task_name === el.data.task_name
      ).target_table;
      this.targetTableText = target_table;
      this.getTaskWithColumnName(target_table);
    } catch (error) {
      Message.error(error as string);
    }
  };
  getTaskWithColumnName(taskName: string) {
    getTableWithColumnNames(taskName, this.source).then((res) => {
      var model = res.data.map((item: any) => {
        return {
          COLUMN_NAME:
            item.DATA_TYPE === 'int' || item.DATA_TYPE === 'datetime'
              ? item.COLUMN_NAME + ' --- ' + item.DATA_TYPE
              : item.COLUMN_NAME +
                ' --- ' +
                item.DATA_TYPE +
                '(' +
                item.CHARACTER_MAXIMUM_LENGTH +
                ')',
        };
      });
      this.setState({ TaskWithColumnData: model });
    });
  }
  private taskOnChange(args: any) {
    this.taskName = args.target.text;
    var target_table = this.state.TaskData.find(
      (x: any) => x.task_name === this.taskName
    ).target_table;
    this.targetTableText = target_table;
    this.getTaskWithColumnName(target_table);
    $('.list-logic').css('display', 'flex');
    //  var element=document.querySelector(".list-logic");
    // element?.classList.add("hideDiv")
  }
  render() {
    return (
      <div className='business-logic-configuration'>
        <GridComponent
          dataSource={this.state.GridData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.gridLogic = g)}
          height='75vh'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines={'Both'}
          rowSelected={this.rowSelect.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='task_name'
              headerText='Task'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
            />
            <ColumnDirective
              field='condition'
              headerText='Condition'
              textAlign='Left'
            />
            <ColumnDirective
              field='component_name'
              headerText='Component'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>
        <div className='control-pane-dialogAdd'>
          <div
            id='targetElementAddTrades'
            className='col-lg-12 defaultDialogAddTrades dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogAddTrades'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                width={'700px'}
                height={'auto'}
                header='Business Logic Configuration'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='container comp-dizayn'>
                  <div className='flex-group-field'>
                    <div className='form-group'>
                      <label htmlFor='Task' className='label-control col-md-3'>
                        Task
                      </label>
                      <div className='col-md-9'>
                        <DropDownListComponent
                          dataSource={this.state.TaskData}
                          fields={this.fieldTask}
                          placeholder='Task'
                          ref={(scope) => {
                            this.taskObj = scope;
                          }}
                          text={this.taskName}
                          onChange={this.taskOnChange.bind(this)}
                        />
                      </div>
                    </div>
                    <div className='form-group'>
                      <label
                        htmlFor='Description'
                        className='label-control col-md-3'
                      >
                        Description
                      </label>
                      <div className='col-md-9'>
                        <TextBoxComponent
                          value={this.description}
                          onChange={(e: any) => {
                            this.description = e.target.value;
                          }}
                          placeholder='Description'
                        />
                      </div>
                    </div>
                    <div className='form-group'>
                      <label
                        htmlFor='Condition'
                        className='label-control col-md-3'
                      >
                        Condition
                      </label>
                      <div className='col-md-9'>
                        <TextBoxComponent
                          created={
                            (this.onCreateConditionTextArea =
                              this.onCreateConditionTextArea.bind(this))
                          }
                          ref={(scope) => {
                            this.textareaObjCondition = scope;
                          }}
                          value={this.condition}
                          onChange={(e: any) => {
                            this.condition = e.target.value;
                          }}
                          multiline={true}
                          style={{ maxHeight: '100px' }}
                          placeholder='Condition'
                        />
                      </div>
                    </div>
                    <div className='form-group'>
                      <label
                        htmlFor='Component'
                        className='label-control col-md-3'
                      >
                        Component
                      </label>
                      <div className='col-md-9'>
                        <DropDownListComponent
                          value={this.componentName}
                          text={this.componentName}
                          fields={this.fieldComp}
                          index={this.selectedCompIndex}
                          onChange={(e: any) => {
                            this.componentName = e.target.text;
                          }}
                          dataSource={this.DataComponent}
                          placeholder='Component'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='list-logic'>
                    <ListViewComponent
                      id='list-taskmanager-column'
                      dataSource={this.state.TaskWithColumnData}
                      fields={this.fieldsTaskColumnList}
                      showCheckBox={false}
                      headerTitle={`columns of table ${this.targetTableText}`}
                      showHeader={true}
                      sortOrder='Ascending'
                      width={250}
                      height={350}
                    ></ListViewComponent>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialogDeleteLogic ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogDelete'
                showCloseIcon={true}
                visible={this.state.hideDialogDeleteLogic}
                header='Confirmation'
                width={200}
                height={'auto'}
                buttons={this.buttonsForDelete}
                open={() => {
                  this.setState({ hideDialogDeleteLogic: true });
                }}
                close={() => {
                  this.setState({ hideDialogDeleteLogic: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>Are you sure?</span>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default BusinessLogiConfiguration;
